import axios from 'axios'
import { getToken } from './loginVerification'

export const updateInstructor = async(id, name, telefon, zameranie) => {
    const tokenData = await getToken();
    if(!tokenData.ok) return { ok: false, message: 'Neprihlásený používateľ!' };
    try {
        const instance = axios.create({
            headers: {'Authorization': 'Bearer '+ tokenData.token}
        });
        const resp = await instance.put(`${process.env.REACT_APP_API_HOST}/instructors/update-instructor/${id}`, {
            name: name,
            telefon: telefon,
            zameranie: zameranie
        });
        return resp.data;
    } catch (error) {
        console.error('Error updating instructor:', error);
        return { ok: false, message: 'Chyba pri ukladaní inštruktora' };
    }
}
